import React, { Component, Fragment } from 'react';
import { View, AppHeader, Avatar, FlatList, Switch, Text, Link, ASButton, FilePicker, isNative, Confirm } from 'core';
import * as actions from 'actions';
import ConvMember from './conv_member';
import { getUploadedFiles, getFileFromUploadsGroup } from 'selectors';
import { theme, style, GROUP_ROLES, isMVP } from 'constants';
import { IcoGallery, IcoMute, IcoCode, IcoEdit } from 'icons';
import { lang } from 'lang';
import { imageProcessor } from 'utils';

export class GroupInfo extends Component {
    state = { active_code: !!this.props.selected.code };

    toggelJoinGroup = async selected => {
        await this.setState({ active_code: !this.state.active_code });
        this.state.active_code ? actions.sendOpenGroup({ group_id: selected.id }) : actions.sendCloseGroup({ group_id: selected.id });
    };

    _uploadGroupAvatar = async files => {
        const { id } = this.props.selected;
        const file = await imageProcessor.process(files[0]);

        actions.sendFiles({
            g_id: 'group_avatar',
            u_id: id,
            files: [file],
            onSuccess: () => actions.sendGroupAvatar({ upload: getUploadedFiles({ g_id: 'group_avatar', u_id: id })[0], group_id: id })
        });
    };

    HeaderComp = ({ selected, members, is_admin, avatar_status, upload_avatar }) => {
        const options = [
            {
                icon: IcoEdit,
                text: lang.EDIT_GROUP_INFO,
                onPress: actions.clickEditGroupInfo
            },
            {
                icon: IcoGallery,
                text: lang.CHANGE_AVATAR,
                onPress: () => FilePicker.show({ asset_type: FilePicker.TYPES.IMAGE }, this._uploadGroupAvatar)
            }
        ];
        return (
            <View style={styles.container}>
                <View style={styles.avatar_cont}>
                    <Avatar
                        is_large
                        data={selected}
                        size={140}
                        avatar_status={avatar_status}
                        file={getFileFromUploadsGroup(upload_avatar, selected.id)}
                        onUploadSuccess={() => {
                            actions.markUploadFinished({ g_id: 'group_avatar', u_id: selected.id });
                            actions.fetch.markFinished(avatar_status.type);
                        }}
                    />
                    <Text style={styles.title}>{selected.title}</Text>
                    <Text style={styles.description}>{selected.description}</Text>
                </View>
                {is_admin ? <ASButton options={options} style={{ position: 'absolute', top: 0, right: 0 }} /> : null}
                <View style={styles.section_devider} />
                <View style={styles.item_list}>
                    <View style={styles.inv_code}>
                        <IcoCode size={25} style={{ marginRight: 5 }} />
                        {selected.code ? (
                            <View>
                                <Text style={styles.inv_code_title}>{lang.JOIN_OPENED}</Text>
                                <Text style={styles.inv_code_subtitle}>
                                    {lang.INV_CODE} {selected.code}
                                </Text>
                            </View>
                        ) : (
                            <View>
                                <Text style={styles.inv_code_title}>{lang.JOIN_CLOSED}</Text>
                                <Text style={styles.inv_code_subtitle}>{lang.JOIN_CLOSE_MSG}</Text>
                            </View>
                        )}
                    </View>
                    {is_admin ? <Switch onValueChange={() => this.toggelJoinGroup(selected)} value={this.state.active_code} /> : null}
                </View>
                {isMVP ? null : (
                    <Fragment>
                        <Link style={styles.item_list} onPress={() => console.log('clicked')}>
                            <IcoGallery size={25} color={theme.gray_color} style={{ marginRight: 5 }} />
                            <Text style={styles.item_text}>{lang.GALLERY}</Text>
                        </Link>
                        <Link style={styles.item_list} onPress={() => {}}>
                            <IcoMute size={25} color={theme.gray_color} style={{ marginRight: 5 }} />
                            <Text style={styles.item_text}>{lang.MUTE}</Text>
                        </Link>
                        <View style={[styles.section_devider, styles.item_list]}>
                            <Text style={styles.label}>{members && members.length + ' ' + lang.PATICIPANTS(members.length)}</Text>
                            <Link size={theme.font_sm} title={lang.SEARCH} onPress={() => {}} selected />
                        </View>

                        <View style={styles.tab_section}>
                            <Link style={styles.item_list} onPress={() => {}}>
                                <Text style={styles.item_text}>{lang.ADD_PARTICIPANT}</Text>
                            </Link>
                        </View>
                    </Fragment>
                )}
            </View>
        );
    };

    FooterComp = ({ selected, user_id, is_admin }) => (
        <View style={{ marginBottom: 10 }}>
            <View style={styles.section_devider} />
            {selected.total_block && is_admin ? (
                <View style={styles.center}>
                    <Link onPress={() => actions.clickBlockedMembers()} title={lang.BLOCKED_MEMBERS} selected />
                </View>
            ) : null}
            <View style={styles.center}>
                <Link
                    onPress={() =>
                        Confirm(() =>
                            actions.sendLeaveGroup({
                                conv_id: selected.id,
                                member_id: user_id,
                                role: GROUP_ROLES.LEFT
                            })
                        )
                    }
                    title={lang.LEAVE_GROUP}
                    selected
                />
            </View>
        </View>
    );
    render() {
        const { members, selected, is_admin, user_id, avatar_status, upload_avatar } = this.props;
        return (
            <Fragment>
                {isNative ? <AppHeader show_connecting back={1} title={selected.title} /> : null}
                <FlatList
                    ListHeaderComponent={<this.HeaderComp selected={selected} members={members} is_admin={is_admin} avatar_status={avatar_status} upload_avatar={upload_avatar} />}
                    style={{ backgroundColor: 'white' }}
                    ListFooterComponent={<this.FooterComp selected={selected} user_id={user_id} is_admin={is_admin} />}
                    keyExtractor={item => item.id}
                    data={members}
                    renderItem={({ item }) => <ConvMember group_id={selected.id} is_admin={is_admin} user_id={user_id} member={item} />}
                />
            </Fragment>
        );
    }
}

const styles = style({
    container: {},
    avatar_cont: {
        marginVertical: 20,
        alignItems: 'center'
    },
    center: {
        alignSelf: 'center',
        marginVertical: 10
    },
    item_list: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 10,
        paddingVertical: 15
    },
    item_text: {
        color: theme.primary_color
    },
    title: {
        textAlign: 'center',
        fontSize: 20,
        margin: 10
    },
    description: {
        textAlign: 'center',
        color: theme.gray_color_lighten(0.4)
    },
    section_devider: {
        backgroundColor: theme.gray_color_lighten(0.05),
        height: 50
    },
    label: {
        color: theme.gray_color_lighten(0.6),
        flex: 1,
        fontSize: theme.font_sm
    },

    member: {
        padding: 10
    },
    inv_code: {
        flexDirection: 'row',
        flex: 1,
        alignItems: 'center'
    },
    inv_code_title: {
        color: theme.gray_color
    },
    inv_code_subtitle: {
        fontSize: theme.font_sm,
        color: theme.gray_color_lighten(0.4),
        paddingTop: 5
    }
});



// WEBPACK FOOTER //
// ./src/components/right/group_info.js